<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">设备详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="AP名称" prop="Name">
                <el-input v-model="data.Name" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="IP地址" prop="IP">
                <el-input v-model="data.IP" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="MAC地址" prop="MAC">
                <el-input v-model="data.MAC" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="连接人数" prop="VisitorCount">
                <el-input
                  v-model="data.VisitorCount"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="区域" prop="Extend1">
                <el-select
                  v-model="data.Extend1"
                  :disabled="!IsEdit"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in EqRegionArr"
                    :key="item.RegionId"
                    :label="item.RegionName"
                    :value="item.RegionName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地理位置" prop="Location">
                <el-input
                  v-model="data.Location"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" prop="Longitude">
                <el-input
                  v-model="data.Longitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="纬度" prop="Latitude">
                <el-input
                  v-model="data.Latitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <ZjLngLatSelect
              class="newtaskposition"
              :point_lat="data.Latitude"
              :point_lng="data.Longitude"
              @onGotLngLat="onGotLngLat"
            ></ZjLngLatSelect>
            <!-- <el-button @click="getCurrentPostion()" style="margin-left:1.5rem;">定位</el-button> -->
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";

export default {
  name: "WifiDeviceManagerEdit",
  controller: "UI",
  action: "WifiDeviceManagerEdit",
  data() {
    return {
      data: {
        Extend1: "",
        Latitude: "",
        Longitude: "",
      },
      EqRegionArr: [],
      ServiceHttpTypeArr: [
        { value: "POST", label: "POST" },
        { value: "GET", label: "GET" },
      ],
      ApiValueFieldTypeArr: [
        { value: "number", label: "数值" },
        { value: "string", label: "字符串" },
      ],
      CompareTypeArr: [
        { value: ">", label: "大于" },
        { value: "=", label: "等于" },
        { value: "<", label: "小于" },
      ],
      IsEdit: false,
      rules: {
        Name: [{ required: true, message: "请输入AP名称", trigger: "blur" }],
        IP: [{ required: true, message: "请输入IP地址", trigger: "blur" }],
        MAC: [{ required: true, message: "请输入MAC地址", trigger: "blur" }],
        Location: [
          { required: true, message: "请输入地理位置", trigger: "blur" },
        ],
        Extend1: [{ required: true, message: "请选择区域", trigger: "change" }],
        VisitorCount: [
          {
            required: false,
            message: "请输入有效的连接人数",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/,
          },
        ],
        Longitude: [
          {
            required: false,
            message: "请输入有效的经度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        Latitude: [
          {
            required: false,
            message: "请输入有效的纬度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
      },
    };
  },
  created: function () {
    this.getRegionInfo();
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  watch: {
    $route: function () {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    onGotLngLat(obj) {
      this.data.Latitude = obj.lat || 0;
      this.data.Longitude = obj.lng || 0;
    },
    getRegionInfo() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionList()
        .GetRegionInfos(RegionInfo)
        .then((r) => {
          r = r.data.Data;
          console.log(r);
          this.EqRegionArr = r;
          // this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        let searchInfo = {
          Id: InfoId,
          PageSize: 20,
          PageIndex: 1,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0,
        };
        new MyApis.TranResourcesApi()
          .GetWifiDeviceById(searchInfo)
          .then((r) => {
            r = r.data.Data;
            console.log(r);
            this.data = r;
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      let uuid = "";
      if (this.$route.query.type == "edit") {
        uuid = this.$route.query.InfoId;
      } else {
        uuid = ZJApp.ZJUtils.uuid();
      }
      if (this.$route.query.type == "edit") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .UpdateWifiDevice(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "wifi设备修改";
            this.logInfo.LogMessage = "wifi设备修改";
            this.logInfo.ModuleName = "设备管理";
            this.logInfo.PageName = "wifi设备管理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Validity: 1, //新增编辑是1，删除是0
          Status: 0, //0离线，1在线
          Id: uuid,
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .AddWifiDevice(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "wifi设备添加";
            this.logInfo.LogMessage = "wifi设备添加";
            this.logInfo.ModuleName = "设备管理";
            this.logInfo.PageName = "wifi设备管理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>